<div class="top">
	<span class="title">Appointments</span>
	<mat-form-field class="location">
		<mat-label>Location</mat-label>
		<mat-select class="location" value="arlington">
			<mat-option value="arlington">Arlington, TX</mat-option>
			<mat-option value="austin>">Austin, TX</mat-option>
		</mat-select>
	</mat-form-field>
</div>

<router-outlet></router-outlet>
